import React from "react";
import {
  Box,
  Stack,
  Paper,
  Grid,
  Typography,
  TextField,
  Button,
} from "@mui/material";
import { useStyles } from "../style";

import { useNavigate } from "react-router-dom";
import { FieldArray, Formik } from "formik";
import { useExamAndGradeStore } from "../../../../Hooks/examAndGrade";
import moment from "moment";
import { useRef } from "react";

const initvalues = { marks: [] };
const UpdateMarks = () => {
  const classes = useStyles();
  const updateMarks = useRef();
  const { studentDetails, studentMarksData, UpdateSubjectMarksAction } =
    useExamAndGradeStore();
  const navigate = useNavigate();

  const currentStudent = React.useMemo(
    () =>
      studentMarksData?.studentSubjectMarks.findIndex(
        (_el) => _el.studentId === studentDetails?.idStudent
      ),
    [studentDetails, studentMarksData?.studentSubjectMarks]
  );

  // //console.log("currentStudent", studentMarksData[currentStudent]);

  React.useEffect(() => {
    //console.log("currentStudent", currentStudent);
    if (currentStudent !== -1) {
      const marks =
        studentMarksData.studentSubjectMarks[currentStudent].studentMarks;
      //console.log("marks", marks);
      updateMarks.current.setFieldValue("marks", marks);
    }
  }, [currentStudent, studentMarksData.studentSubjectMarks]);
  return (
    <Stack className={classes.exam}>
      <Paper elevation={3} sx={{ width: "80%", borderRadius: "25px" }}>
        <Stack sx={{ marginLeft: "20px" }}>
          <p className={classes.add_course_text}>Update Mark</p>
        </Stack>
        <Grid container spacing={1}>
          <Grid item lg={6} md={12} style={{ padding: "20px", width: "100%" }}>
            <Stack
              sx={{
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Stack>
                <Typography className={classes.label}>Student Id</Typography>
              </Stack>
              <Stack>
                <TextField
                  id="classname"
                  type="text"
                  name="classname"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  disabled
                  value={studentDetails?.idStudent}
                  sx={{
                    width: 240,
                  }}
                  placeholder="Enter Student ID"
                />
              </Stack>
            </Stack>
            <Stack
              sx={{
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: "10px",
              }}
            >
              <Stack>
                <Typography className={classes.label}>Student Name</Typography>
              </Stack>
              <Stack>
                <TextField
                  id="classname"
                  type="text"
                  name="classname"
                  disabled
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={studentDetails?.studentName}
                  sx={{
                    width: 240,
                  }}
                  placeholder="Enter Student Name"
                />
              </Stack>
            </Stack>
            <Stack
              sx={{
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: "10px",
              }}
            >
              <Stack>
                <Typography className={classes.label}>Program Type</Typography>
              </Stack>
              <Stack>
                <TextField
                  id="classname"
                  type="text"
                  name="classname"
                  disabled
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={studentDetails?.programType}
                  sx={{
                    width: 240,
                  }}
                  placeholder="Enter Program Type"
                />
              </Stack>
            </Stack>
            <Stack
              sx={{
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: "10px",
              }}
            >
              <Stack>
                <Typography className={classes.label}>Course Name</Typography>
              </Stack>
              <Stack>
                <TextField
                  id="classname"
                  type="text"
                  name="classname"
                  disabled
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={studentDetails?.courseName}
                  sx={{
                    width: 240,
                  }}
                  placeholder="Enter Course Name"
                />
              </Stack>
            </Stack>
            <Stack
              sx={{
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: "10px",
              }}
            >
              <Stack>
                <Typography className={classes.label}>Course Year</Typography>
              </Stack>
              <Stack>
                <TextField
                  id="classname"
                  type="text"
                  name="classname"
                  disabled
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={studentDetails?.courseYear}
                  sx={{
                    width: 240,
                  }}
                  placeholder="Enter Course Year"
                />
              </Stack>
            </Stack>
          </Grid>
          <Grid item lg={6} md={12} style={{ padding: "20px", width: "100%" }}>
            <Stack
              sx={{
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: "80px",
                marginRight: "10px",
              }}
            >
              <Typography className={classes.label}>Exam Start Date</Typography>
              <Stack>
                <TextField
                  id="to"
                  type="date"
                  name="to"
                  disabled
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={moment(studentDetails?.startDate).format("YYYY-MM-DD")}
                  sx={{
                    width: 240,
                  }}
                  placeholder="Enter Exam Start Date"
                />
              </Stack>
            </Stack>
            <Stack
              sx={{
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: "10px",
                marginRight: "10px",
              }}
            >
              <Typography className={classes.label}>Exam End Date</Typography>
              <Stack>
                <TextField
                  id="to"
                  type="date"
                  name="to"
                  disabled
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={studentDetails?.endDate}
                  sx={{
                    width: 240,
                  }}
                  placeholder="Enter Exam End Date"
                />
              </Stack>
            </Stack>
          </Grid>
        </Grid>
      </Paper>
      <Paper
        elevation={3}
        sx={{ width: "90%", borderRadius: "25px", marginTop: "20px" }}
      >
        <Stack sx={{ dispaly: "block" }}>
          <Formik
            initialValues={initvalues}
            validateOnBlur={false}
            validateOnChange={false}
            enableReinitialize
            onSubmit={(values) => {
              //console.log("UpdateSubjectMarksAction", values);
              UpdateSubjectMarksAction({
                studentExamId:
                  studentMarksData.studentSubjectMarks[currentStudent]
                    .studentExamId,
                subjectMarks: values.marks,
              });
            }}
            innerRef={updateMarks}
          >
            {(formik) => {
              const {
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                setFieldValue,
                values,
              } = formik;
              //console.log("value", values);
              return (
                <>
                  <form
                    onSubmit={handleSubmit}
                    className={classes.attendanceForm}
                  >
                    <FieldArray
                      name="marks"
                      render={(arrayHelpers) => {
                        return (
                          values.marks.length > 0 &&
                          values.marks.map((row, index) => {
                            return (
                              <Stack
                                sx={{
                                  flexDirection: "row",
                                  alignItems: "center",
                                  display: "flex",
                                  padding: "20px",
                                  justifyContent: "space-between",
                                  width: "100%",
                                  flexWrap: "wrap",
                                  rowGap: 4,
                                }}
                              >
                                <Typography className={classes.textgap}>
                                  {row.subjectName}
                                </Typography>
                                <TextField
                                  disabled
                                  // id="subjectName"
                                  name={`marks.${index}.subjectName`}
                                  placeholder="Enter subject"
                                  className={
                                    errors.subjectName && touched.subjectName
                                      ? classes.inputError
                                      : classes.inputNoError
                                  }
                                  // onBlur={handleBlur}
                                  onChange={(e) => {
                                    setFieldValue(
                                      `marks.${index}.subjectName`,
                                      e.target.value
                                    );
                                  }}
                                  value={row.subjectName}
                                />
                                <TextField
                                  // id="marks"
                                  name={`marks.${index}.marks`}
                                  placeholder="Enter marks"
                                  className={
                                    errors.marks && touched.marks
                                      ? classes.inputError
                                      : classes.inputNoError
                                  }
                                  // onBlur={handleBlur}
                                  onChange={(e) => {
                                    setFieldValue(
                                      `marks.${index}.marks`,
                                      e.target.value
                                    );
                                  }}
                                  value={row.marks}
                                />
                                <Typography className={classes.textgap}>
                                  Exam End Date
                                </Typography>
                                <TextField
                                  // id="date"
                                  type="date"
                                  name="returnDate"
                                  defaultValue="2022-12-24"
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  placeholder="Enter Exam End Date"
                                />
                              </Stack>
                            );
                          })
                        );
                      }}
                    />

                    <Stack sx={{ padding: "20px", width: "90%" }}>
                      <div style={{ display: "flex", justifyContent: "end" }}>
                        <Button
                          type="button"
                          sx={{
                            px: 1,
                            py: 1,
                            borderRadius: "50px",
                            marginRight: "20px",
                          }}
                          className={classes.cancel_btn}
                          onClick={() => {
                            navigate("/exam");
                          }}
                        >
                          Cancel
                        </Button>
                        <Button
                          type="submit"
                          sx={{ px: 1, py: 1, borderRadius: "50px" }}
                          className={classes.search_btn}
                        >
                          Update
                        </Button>
                      </div>
                    </Stack>
                  </form>
                </>
              );
            }}
          </Formik>
        </Stack>
      </Paper>
    </Stack>
  );
};

export default UpdateMarks;
